<template>
  <div >
    <div>
      <resource-nav-bar
          v-if="resource"
          :resource="resource"
          @open-about="handleAboutClick"
      >
        <template v-slot:buttons-right>
          <b-button
              variant="outline-primary"
              size="md"
              class="my-2 my-md-0"
              @click="handleOpenExportModal('copy')"
              style="margin: 10px"
          >
            <b-icon icon="clipboard"></b-icon>
          </b-button>
          <b-button
              variant="outline-primary"
              size="md"
              class="my-2 my-md-0"
              :disabled="true"
              @click="handleOpenExportModal('print')"
              style="margin: 10px"
          >
            <b-icon icon="printer"></b-icon>
          </b-button>
          <b-button
              variant="outline-primary"
              size="md"
              class="my-2 my-md-0"
              @click="handleOpenExportModal('pdf')"
              style="margin: 10px"
          >
            <b-icon icon="cloud-download"></b-icon>
          </b-button>
          <b-button
              variant="outline-primary"
              size="md"
              class="my-2 my-md-0"
              @click="handleOpenExportModal('email')"
              style="margin: 10px"
          >
            <b-icon icon="envelope"></b-icon>
          </b-button>
        </template>
      </resource-nav-bar>
    </div>
    <pane-intro/>
    <pane-entry
        style="margin-top: 25px;"
        :ref="paneEntryRefId"
        :generating="generating"
        @generate-click="handleGenerateClick"
    />
    <pane-response
        style="margin-top: 25px;"
        :curr-doc="currDoc"
        :path="path"
        :profile="profile"
        :max-words="maxFilteredWords"
        :idx="currIdx"
        :output="currOutput"
        :is-generating="generating"
        @page-to="handlePageTo"
    />
    <export-modal
        :modal-id="exportModalId"
        :export-type-id="selectedExportTypeId"
        :curr-idx="currIdx"
        :outputs="outputsArr"
    />
  </div>
</template>

<script>
import ResourceBlockDisplay from "@/mixins/resourceBlocks/Display";
import ResourceNavBar from "@/components/blockResources/_components/resourceNavBar";
import firebase from "firebase";
import PaneIntro from "./paneIntro";
import PaneEntry from "./paneEntry";
import PaneResponse from "./paneResponse";
import ExportModal from "./exportModal";
import {mapGetters} from "vuex";

export default {
  name: "Display_LinkedInPoll",
  mixins: [ResourceBlockDisplay],
  components: {
    ResourceNavBar,
    PaneIntro,
    PaneEntry,
    PaneResponse,
    ExportModal
  },
  created(){
    this.checkProfile();
    },
  mounted() {
    if (this.profile && this.myAppId) {
      this.setUpSnapShot();
    }
  },
  props: {
    isDemo: {
      type: Boolean,
      required: false,
      default: false
    },
    pathPublishing: {
      type: String,
      default: null
    },
  },
  computed: {
      ...mapGetters({
        profile: "user/profile",
    }),
    filteredPollGroups(){
      return this.thePollGroups && Array.isArray(this.thePollGroups) ?
          this.thePollGroups.filter((theWord)=>{return theWord.status && theWord.status.state
              && theWord.status.state == "COMPLETED"})
          : [];
    },
    filteredWordsOrdered(){
      let _words = this.filteredPollGroups;
      return _words && Array.isArray(_words) ?
          _words.sort((a, b)=> {
            if (a._created_at && b._created_at && a._created_at.seconds && b._created_at.seconds) {
              this.momentTest = a._created_at.seconds
              return a._created_at.seconds - b._created_at.seconds;
            } return false;
          }) : [];
    },
    maxFilteredWords(){
        return this.filteredWordsOrdered && Array.isArray(this.filteredWordsOrdered) && this.filteredWordsOrdered.length ?
            this.filteredWordsOrdered.length : 0
    },
    userId() {
        return  this.profile && this.profile.userId ? this.profile.userId : null;
    },
    firstname() {
      return this.profile && this.profile.firstname ? this.profile.firstname : null;
    },
    path(){
        if(!this.isDemo) {
          return this.userId && this.myAppId ?
              `/users/${this.userId}/lists/__apps/data/${this.myAppId}/ai_poll` : '';
        }
       return this.pathPublishing?
          `${this.pathPublishing}/ai_poll` : '';
    },
    currDoc(){
      return this.filteredWordsOrdered && Array.isArray(this.filteredWordsOrdered) &&
      this.filteredWordsOrdered.length > this.currIdx  ? this.filteredWordsOrdered[this.currIdx] : null
    },
    currOutput() {
        return this.currDoc && this.currDoc.output ? this.convertOutputToJSON(this.currDoc.output) : null;
    }
  },
  methods: {
    checkProfile() {
      if (this.profile) return;
      this.$store.dispatch("user/getProfile");
    },
    setUpSnapShot() {
      if (this.path) {
        const db = firebase.firestore();
        this.collectionRef = db.collection(this.path);

        this.unsub = this.collectionRef.onSnapshot(snapshot => {
          this.thePollGroups = [];
          snapshot.docs.forEach((doc) => {
                this.thePollGroups.push({...doc.data(), id: doc.id});
              }
          )
          if (this.isEntry) {
            this.currIdx = this.filteredWordsOrdered && Array.isArray(this.filteredWordsOrdered) ?
                this.filteredWordsOrdered.length - 1 : 0;
            this.isEntry = false;
          }
          //Check this that the current Payload

          if(this.currPayloadId) { //Handle teh processing of a submission
            let currentPayload = this.thePollGroups.filter((aPayload)=>{
              return aPayload.genId == this.currPayloadId;
            });

            if (currentPayload && Array.isArray(currentPayload)) {
              let thisPayLoad = currentPayload[0];
              if (thisPayLoad && thisPayLoad.status && thisPayLoad.status.state) {
                if (thisPayLoad.status.state == 'PROCESSING') {
                  this.generating = true;
                } else if (thisPayLoad.status.state == 'COMPLETED') {
                  //clear textbox
                  let paneEntryComponent = this.$refs[this.paneEntryRefId];
                  if (paneEntryComponent.hasOwnProperty("resetForm")) {
                    paneEntryComponent.resetForm();
                  }
                  //stop loading
                  this.generating = false;

                  //Move to last position- using the filtered
                  this.currIdx = this.filteredWordsOrdered && Array.isArray(this.filteredWordsOrdered) ?
                      this.filteredWordsOrdered.length - 1 : 0;

                  //Clear Id
                  this.currPayloadId = null;
                } else if (thisPayLoad.status.state == 'ERRORED') {
                  this.generating = false;
                }
              }
            }
          }
        });
      }
    },
    handleGenerateClick(entryInput) {
      this.generateEntry(entryInput.replace(/(^"|"$)/g, ''));
    } ,
    generateEntry(entryInput) {
      let profileBy = this.profileBy();
      this.currPayloadId = `gen_${Date.now()}`;

      let payload = {
        genId: this.currPayloadId,
        _created_at: new Date(),
        _created_by: profileBy,
        subject: entryInput
      };

      this.collectionRef.add(payload); // Include values for { unspecified parameter } fields

      this.generating = true;
    },
    handleResetForm(){
        this.input = "";
    },
    profileBy() {
      return {
        uid: this.profile && this.profile.userId ? this.profile.userId : null,
        name: this.profile
            ? `${this.profile.firstname} ${this.profile.lastname}`
            : null,
        imgURL: this.profile ? this.profile.imgURL : null
      };
    },
    convertOutputToJSON(responseOutput) {
      let output = {};

      if (responseOutput) {
        try {
          output = responseOutput.replace(/(\r\n|\n|\r)/gm, "");
          output = JSON.parse(output);
        } catch (e) {
          console.error(e); // error in the above string (in this case, yes)!
        }
      }
      return output;
    },
    handlePageTo(pageNumber) {
      this.currIdx = pageNumber;
    },
    handleOpenExportModal(exportTypeId){
      this.selectedExportTypeId=exportTypeId;
      this.outputsArr = this.createArrayOfOutputs();
      this.$bvModal.show(this.exportModalId);
    },
    createArrayOfOutputs(){
      let outputsArr=[];
      this.filteredWordsOrdered.forEach((aWordsDoc)=>{
        outputsArr.push(this.convertOutputToJSON(aWordsDoc.output));
      });
      return outputsArr;
    }
  },
  watch: {
    path(newValue, oldValue) { //temp- may take out
      if (newValue) {
        this.setUpSnapShot();
      }
    },
    filteredPollGroups(newValue, oldValue) { //temp- may take out
      if (newValue) {
        //this.currIdx = newValue && Array.isArray(newValue) ? newValue.length - 1  : 0;
      }
    }
  },
  data() {
    return {
      isEntry: true,
      currIdx : 0,
      currPayloadId: null,
      exportModalId:"export-modal-id",
      selectedExportTypeId: null, //email|pdf|printer
      outputsArr:[],
      input: "",
      myAppId: this.resource && this.resource.toolId ? this.resource.toolId : null,
      collectionRef: null,
      thePollGroups:[],
      generating: false,
      paneEntryRefId:"pane-entry"
    };
  }
};
</script>

<style lang="scss" scoped>
</style>
